import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { tenant } from '@/constants/config'
// import { useUtils as useAclUtils } from '@core/libs/acl'

const { t } = useI18nUtils()
// const { canViewVerticalNavMenuHeader } = useAclUtils()

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tenant,
    }
  },
  render(h) {
    const span = h('span', {}, t(this.item.header))
    const icon = h('feather-icon', { props: { icon: 'MoreHorizontalIcon', size: '18' } })
    const liClass = {
      'navigation-header': true,
      'text-truncate': true,
      'royal-navigation-header': this.tenant === 'royalexpress',
    }
    // if (canViewVerticalNavMenuHeader(this.item)) {
    return h('li', { class: liClass }, [span, icon])
    // }
    // return h()
  },
}
